<template>
  <div class="billingPayment">
    <div class="billingPayment__wrap">
      <AppWithLoading :fetch="fetch">
        <template v-slot:default="{loader}">
          <div v-if="billingPayments.length">
            <table class="billing-payment-table" v-if="billingPayments.length">
              <thead>
                <tr class="billing-payment-table__header">
                  <th class="billing-payment-table__header-item">
                    {{ $t('date') }}
                  </th>
                  <th class="billing-payment-table__header-item">
                    {{ $t('id') }}
                  </th>
                  <th class="billing-payment-table__header-item">
                    {{ $t('status') }}
                  </th>
                  <th class="billing-payment-table__header-item">
                    {{ $t('itemType') }}
                  </th>
                  <th class="billing-payment-table__header-item">
                    {{ $t('tariff') }}
                  </th>
                  <th class="billing-payment-table__header-item">
                    {{ $t('amount') }}
                  </th>
                </tr>
              </thead>
              <template v-if="billingPayments">
                <tbody>
                  <BillingPaymentItem
                    v-for="billingPayment of billingPayments"
                    :key="billingPayment.id"
                    :billing-payment="billingPayment"
                  />
                </tbody>
              </template>
            </table>
            <template v-if="metaData">
              <v-pagination
                :value="page"
                @input="loader(()=> loadPage($event))"
                :length="metaData.lastPage"
              />
            </template>
          </div>
          <div v-else>
            {{ $t('noPayments') }}
          </div>
        </template>
      </AppWithLoading>
    </div>
  </div>
</template>

<script>
import useBillingPayment from '@/compositions/accounting/useBillingPayment';
import BillingPaymentItem from '@/components/Payment/Payments/BillingPaymentItem';
import { ref, watch } from '@vue/composition-api';
import AppWithLoading from '@/components/AppWithLoading';

export default {
  name: 'BillingPayments',
  components: {
    AppWithLoading,
    BillingPaymentItem,
  },
  setup() {
    const page = ref(1);
    const {
      fetchAll, billingPayments, metaData, deleteAll,
    } = useBillingPayment();
    const fetchParams = {
      pageValue: 1,
      perPageValue: 20,
    };

    async function fetchAllWithLoading(params) {
      await deleteAll();
      await fetchAll(params);
    }

    async function loadPage(newPage) {
      await fetchAllWithLoading({
        ...fetchParams,
        pageValue: newPage,
      });
      page.value = newPage;
    }

    async function fetch() {
      await fetchAllWithLoading(fetchParams);
    }

    return {
      fetchAllWithLoading,
      fetch,
      loadPage,
      deleteAll,
      metaData,
      billingPayments,
      fetchAll,
      page,
    };
  },
};
</script>

<style lang="scss" scoped>
  .billingPayment {
    padding: 2.1875rem 2.5rem 2.5rem 2.5rem;
    background: #FFFFFF;
    box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
    border-radius: 0.625rem;
    overflow-x: auto;
  }
  .billing-payment-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 2rem;
    &__header-item {
      text-align: center;
      font-size: 1rem;
      padding: 0.5625rem 0.5rem;
      color: rgba(0, 0, 0, 0.6);
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .billingPayment {
      padding: 1.75rem 1.25rem 1.875rem 1.25rem;
    }
    .billing-payment-table {
      margin-bottom: 1.75rem;
      &__header-item {
        font-size: 0.75rem;
        padding: 0.5rem 0.375rem;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .billingPayment {
      padding: 1.25rem 1rem 1.5rem 1rem;
      box-shadow: none;
      overflow-x: hidden;
    }
    .billing-payment-table {
      thead {
        display: none;
      }
      &__header-item {
        text-align: left
      }
      margin-bottom: 1rem;
    }
  }

</style>

<i18n lang="yml" locale="ru">
status: Статус
type: Тип платежа
itemType: Тип услуги
id: Номер счета
date: Дата
amount: Сумма списания
noPayments: Нет прошедших оплат
tariff: Тариф
</i18n>
<i18n lang="yml" locale="en">
status: Status
type: Payment type
itemType: Service type
id: Billing ID
date: Date
amount: Amount
noPayments: No payments yet
tariff: Tariff
</i18n>
